<a
  class="btn btn-action btn-small mb-3 back-navigation"
  [routerLink]="{ cxRoute: 'orders' } | cxUrl"
  [queryParams]="sharedService.getQueryParamsLocal('orders')"
  >
  <i class="fas fa-arrow-left mr-1"></i>
  {{ 'shared.backTo.orderHistory' | cxTranslate }}
</a>

@if (order$ | async; as order) {
  <app-order-details-headline></app-order-details-headline>
  <div class="order-details-items">
    <!-- promotions   -->
    <!-- TODO: Check the business requirements and fix accordingly   -->
    <!-- consigned entries -->
    <!-- TODO: Check the business requirements and fix accordingly   -->
    <!-- unconsigned entries -->
    @if (order?.unconsignedEntries?.length > 0 || order?.entries?.length > 0) {
      <app-custom-cart-item-list
        [items]="order?.unconsignedEntries?.length ? order.unconsignedEntries : order.entries"
        [readonly]="true"
        [promotionLocation]="promotionLocation"
        [order]="order"
        >
      </app-custom-cart-item-list>
    }
  </div>
}
